import { TableId, useCustomTableView } from 'helpers/userPreferences';
import { useEffect, useRef, useState } from 'react';
import { MultiSelectDropDownInput } from './MultiSelectDropDownInput';
import {
  TextButton,
  TextButtonColor,
} from 'components/uikit/buttons/TextButton';
import ManageColumnsIcon from 'assets/icons/manage_columns_24.svg?react';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import styles from './ColumnSelectionDropdown.module.scss';

interface ColumnSelectionButtonProps {
  tableId: TableId;
  options: ColumnSelectionOption[];
  selectedColumns: string[];
  setSelectedColumns: (columns: string[]) => void;
  classes?: {
    button?: string;
  };
}

export type ColumnSelectionOption = {
  value: string;
  label: string;
};

export const ColumnSelectionDropdown = (props: ColumnSelectionButtonProps) => {
  const i18n = useScopedTranslation('Component.TreeControlPanel');

  const buttonRef = useRef<HTMLDivElement>(null);
  const [isColumnsDropdownOpened, setIsColumnsDropdownOpened] = useState(false);
  const [hiddenColumns, setCustomTableView] = useCustomTableView(props.tableId);

  const optionValues = props.options.map((option) => option.value);

  useEffect(() => {
    props.setSelectedColumns(
      optionValues.filter((option) => !hiddenColumns.includes(option)),
    );
  }, []);

  return (
    <div className={styles.wrapper}>
      <div ref={buttonRef}>
        <TextButton
          testId="manage-columns"
          color={TextButtonColor.Primary}
          icon={<ManageColumnsIcon />}
          title={i18n.t('manage_columns')}
          onClick={() => setIsColumnsDropdownOpened((prev) => !prev)}
          className={props.classes?.button}
        />
      </div>

      <MultiSelectDropDownInput
        open={isColumnsDropdownOpened}
        onClose={(e) => {
          if (buttonRef.current?.contains(e.target as Node)) return;
          setIsColumnsDropdownOpened(false);
        }}
        options={optionValues}
        itemSize={40}
        className={styles.columnSelectDropdown}
        getOptionLabel={(x) =>
          props.options.find((option) => option.value === x)?.label || x
        }
        classes={{
          popper: styles.popper,
          option: styles.option,
        }}
        value={props.selectedColumns}
        onValueChanged={(newValues) => {
          setCustomTableView(
            optionValues.filter((option) => !newValues.includes(option)),
          );
          props.setSelectedColumns([...newValues]);
        }}
        invertReset={true}
        hideHeader={true}
        showResetFooter={true}
      />
    </div>
  );
};
